export const tableRows = [
  'w',
  'y',
  'b',
  'p',
  'm',
  'f',
  'd',
  't',
  'n',
  'l',
  'g',
  'k',
  'h',
  'j',
  'q',
  'x',
  'zh',
  'ch',
  'sh',
  'r',
  'z',
  'c',
  's',
];

export const consonants = [
  {
    letter: 'a',
    left: [{ name: 'ai' }, { name: 'ao' }, { name: 'an' }, { name: 'ang' }],
  },
  { letter: 'o', left: [{ name: 'ou' }, { name: 'ong' }] },
  { letter: 'e', left: [{ name: 'ei' }, { name: 'en' }, { name: 'eng' }] },
  {
    letter: 'i',
    left: [
      { name: 'ia' },
      { name: 'ie' },
      { name: 'iu' },
      { name: 'in' },
      { name: 'ing' },
      { name: 'iao' },
      { name: 'ian' },
      { name: 'iang' },
      { name: 'iong' },
    ],
  },
  {
    letter: 'u',
    left: [
      { name: 'ua' },
      { name: 'uo' },
      { name: 'ui' },
      { name: 'un' },
      { name: 'uai' },
      { name: 'uan' },
      { name: 'uang' },
    ],
  },
  { letter: 'ü', left: [{ name: 'üe' }, { name: 'ün' }] },
  { letter: 'ai' },
  { letter: 'ei' },
  { letter: 'ui' },
  { letter: 'ao' },
  { letter: 'ou' },
  { letter: 'iu' },
  { letter: 'ie' },
  { letter: 'ue' },
  { letter: 'an' },
  { letter: 'en' },
  { letter: 'in' },
  { letter: 'un' },
  { letter: 'ang' },
  { letter: 'eng' },
  { letter: 'ing' },
  { letter: 'ong' },
];

export const removeArray = [
  'we',
  'wi',
  'wü',
  'wui',
  'wiu',
  'wie',
  'win',
  'wun',
  'wing',
  'wong',
  'yo',
  'yu',
  'yü',
  'yui',
  'yiu',
  'yie',
  'yen',
  'yeng',
  'be',
  'bü',
  'bong',
  'pe',
  'pü',
  'pong',
  'mü',
  'mong',
  'fe',
  'fü',
  'fong',
  'do',
  'dü',
  'to',
  'tü',
  'no',
  'lo',
  'go',
  'gü',
  'ko',
  'kü',
  'ho',
  'hü',
  'ja',
  'jo',
  'je',
  'ju',
  'jai',
  'jei',
  'jui',
  'jao',
  'jou',
  'jan',
  'jen',
  'jang',
  'jeng',
  'jong',
  'qa',
  'qo',
  'qe',
  'qu',
  'qai',
  'qei',
  'qui',
  'qao',
  'qou',
  'qan',
  'qen',
  'qang',
  'qeng',
  'qong',
  'xa',
  'xo',
  'xe',
  'xu',
  'xai',
  'xei',
  'xui',
  'xao',
  'xou',
  'xan',
  'xen',
  'xang',
  'xeng',
  'xong',
  'zho',
  'zhü',
  'zhiu',
  'zhie',
  'zhin',
  'cho',
  'chü',
  'chiu',
  'chie',
  'chin',
  'sho',
  'shü',
  'shiu',
  'shie',
  'shin',
  'ra',
  'ro',
  'rü',
  'riu',
  'rie',
  'rin',
  'ring',
  'zo',
  'zü',
  'ziu',
  'zie',
  'zin',
  'zing',
  'co',
  'cü',
  'ciu',
  'cie',
  'cin',
  'cing',
  'so',
  'sü',
  'siu',
  'sie',
  'sin',
  'sing',
];
